/* eslint-disable object-curly-newline */
import React from 'react';
import { useSelector } from 'react-redux';

import {
  handleChange,
  handleValidation,
  getValidClass,
  isRequired,
  getOptions,
  getFieldKey,
  fieldShouldDisplay,
} from '../../../../utils/form';

import FormLabel from './FormLabel';

function Select({
  cols = '12',
  clone,
  children,
  disabled,
  name,
  className = '',
  customOptions,
  onChangeCallback = () => {}, // This callback is passed the new value of the field as it's 1st arg
}) {

  const { values, form: { form } } = useSelector(store => store);
  const value = values[name];
  const required = isRequired({ form, name, currentValues: values });

  const validationRegex = useSelector(store => store.validation[name]);
  const defaultLabel = useSelector(store => store.labels[name]);
  const valid = useSelector(store => store.valid[name]);
  const validClass = getValidClass({ valid, required, value });

  const { submittedFlag } = useSelector(store => store.enrollment);
  const isDisabled = (disabled || clone || submittedFlag);

  const options = customOptions || getOptions(form, name);

  const customLabel = getFieldKey(form, name, 'label');

  // if field doesn't exist or is conditionally hidden, don't show it.
  if (!fieldShouldDisplay(form, name, values)) return null;

  return (
    <div className={`col-md-${cols} ${className}`}>
      <FormLabel name={name} label={customLabel || defaultLabel} required={required} />
      <select
        className={['form-select', (!isDisabled ? validClass : '')].join(' ')}
        id={name}
        onChange={(e) => handleChange({
          value: e.target.value,
          name,
          valid,
          validationRegex,
          required,
          onChangeCallback,
        })}
        value={values[clone || name] || ''}
        disabled={isDisabled}
        onBlur={() => handleValidation({ value, validationRegex, name, required })}
      >
        {options ? options.map(option => (
          <option disabled={option.disabled} key={option.value} value={option.value}>{option.label}</option>
        )) : children}
      </select>
    </div>
  );
}

export default Select;
